import React from 'react';
import ReactDOM from 'react-dom';

// * Stylesheet
import './css/global.css';

import App from './App';

ReactDOM.render(<App />, document.getElementById(`root`));